export default __webpack_public_path__ + "static/media/Seesam.b6273b36.png";